module.exports = __webpack_public_path__ + "img/icon3.f59c3ff3.svg";